import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class ReceiptCancellationService {
  token6=""
  constructor(private http :HttpClient,private baseurl:BasemodelService) { }
  recepit(){
    const headers = new HttpHeaders({
      'Authorization': this.token6,
      'Content-Type':'application/json'
    })
    return this.http.get(this.baseurl.getcounsellingURL()+"/jwtV2/api/receipt/approve/getCancelledReceipts",{headers})
    
  
  }
  paymentrecepit(adm:any,recepit:any){
    const headers = new HttpHeaders({
      'Authorization': this.token6,
      'Content-Type':'application/json'
    })
    return this.http.get(this.baseurl.getcounsellingURL()+"/jwtV2/api/receipt/approve/getCancelledReceiptDetails?admNo="+adm+"&encReceiptNo="+recepit,{headers})
                    
  }
  paymentreject(data:any){
    const headers = new HttpHeaders({
      'Authorization': this.token6,
      'Content-Type':'application/json'
    })
    return this.http.post(this.baseurl.getcounsellingURL()+"/jwtV2/api/receipt/approve/saveCancelReceipt",data,{headers})
  }
}
